export default "__VITE_ASSET__dcb6ba80__"